// @ts-nocheck
import { BASE_API_URL,BASE_IMG_URL } from '../lib/axios';
export const imageConfig = {
    uploadUrl: `${BASE_API_URL}/api/pc/file/upload`,
    baseImageUrl:`${BASE_IMG_URL}/imgs/`
  };